<template>

  <vue-chosen
    v-model="selectedItems"
    :name="name"
    :options="options"
    :multiple="true"
    :placeholder="localPlaceholder"
  ></vue-chosen>

</template>

<script>
import { mapState } from 'pinia'
import { useCitizensTrackingStore } from "../../stores/citizensTracking"
export default {

  emits: ['update:modelValue'],

  props: {

    modelValue: {
      type: [String, Number, Array, Object],
      default: '',
    },

    name: {
      type: String,
      required: true
    },

    clientOptions: {
      type: Array,
      default: () => {return []}
    },

    placeholder: {
      type: String,
      default: null
    },
  },

  data: function () {
    return {
      selectedItems: this.modelValue,
    }
  },

  computed: {
    ...mapState(useCitizensTrackingStore, ['filterSelectedClients']),

    options() {
      let items = [];
      this.clientOptions
        .filter(optionGroup => this.filterSelectedClients.indexOf(optionGroup.clientId.toString()) >= 0)
        .map(optionGroup => optionGroup.team)
        .map(team => team.forEach(member => items.push({'value': member.id, 'text': member.name})));
      return [...new Map(items.map(item => [item.value, item])).values()];
    },

    localPlaceholder() {
      if (this.filterSelectedClients.length === 0) return 'Select client first...';
      return this.placeholder;
    }
  },

  watch: {
    selectedItems: {
      deep: true,
      handler (value) {
        this.$emit('update:modelValue', value);
      }
    },
  },

}
</script>
